export default __webpack_public_path__ + "static/media/confetti.2d629313.webp";